import BodyText from '@lyra/core/components/BodyText'
import Icon from '@lyra/core/components/Icon'
import { YieldTokenId } from '@lyra/web/constants/yield'
import { yieldCopy } from '@lyra/web/constants/yieldCopy'
import React from 'react'
import { Stack, StackProps, XStack, YStack } from 'tamagui'

import YieldStackValueText from './YieldStackValueText'

type Props = {
  yieldId: YieldTokenId
} & StackProps

export default function YieldStackYStack({ yieldId, ...stackProps }: Props) {
  const copy = yieldCopy[yieldId]

  return (
    <YStack {...stackProps}>
      {copy.yieldStack.map((item) => (
        <XStack gap="$1.5" alignItems="center" key={item.title}>
          <Stack width={18} height={18} borderRadius={1000} overflow="hidden">
            <Icon color={item.iconColor} size={18} icon={item.icon} />
          </Stack>
          <BodyText color="secondary">{item.title}</BodyText>
          <BodyText marginLeft="auto">
            <YieldStackValueText yieldId={yieldId} layer={item} />
          </BodyText>
        </XStack>
      ))}
    </YStack>
  )
}
